function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var PopupHome = require('./index.js');
var PopupLesson = require('./lib/lesson');
var PopupVocab = require('./lib/vocab');
var PopupReview = require('./lib/review');
var PopupMain = require('./lib/main');
var PopupLessonManager = require('./lib/manager');
var PeerService = require('saito-js/lib/peer_service')["default"];
var JsStore = require('jsstore');
var Popup = /*#__PURE__*/function (_ModTemplate) {
  function Popup(app) {
    var _this;
    _classCallCheck(this, Popup);
    _this = _callSuper(this, Popup, [app]);
    _this.appname = 'Popup Chinese';
    _this.name = 'Popup';
    _this.slug = 'popup';
    _this.description = 'Chinese Language Education on the Saito Network';
    _this.categories = 'Social Entertainment';
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.icon_fa = 'fa-solid fa-language';
    _this.lesson = {}; // if being studied
    _this.show_vocab = false;
    _this.styles = ['/popup/style.css'];
    _this.peers = [];

    // in browser db
    _this.localDB = null;
    _this.social = {
      twitter_card: 'summary',
      twitter_site: '@SaitoOfficial',
      twitter_creator: '@SaitoOfficial',
      twitter_title: 'Popup Chinese',
      twitter_url: 'https://popupchinese.com/',
      twitter_description: 'Popup Chinese - Learn Chinese',
      twitter_image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card_horizontal.png',
      og_title: 'Popup Chinese',
      og_url: 'https://popupchinese.com',
      og_type: 'website',
      og_description: 'Popup Chinese - Learn Chinese',
      og_site_name: 'Popup Chinese',
      og_image: 'https://popupchinese.com',
      og_image_url: 'https://popupchinese.com',
      og_image_secure_url: 'https://popupchinese.com'
    };

    // define database and version
    _this.dbName = 'popup';
    _this.dbVersion = 1;
    _this.lessons = [];
    _this.offset = 0;
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Popup, _ModTemplate);
  return _createClass(Popup, [{
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      services.push(new PeerService(null, 'popup', 'Popup Language Archive'));
      return services;
    }

    ////////////////////
    // initialization //
    ////////////////////
  }, {
    key: "initializeDatabase",
    value: function () {
      var _initializeDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.browser_active) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              return _context2.a(2, new Promise(function (resolve, reject) {
                // Open (or create) the database
                var request = indexedDB.open(_this2.dbName, _this2.dbVersion);
                request.onerror = function (event) {
                  console.error('Database error:', event.target.errorCode);
                  reject(new Error('Failed to open database'));
                };
                request.onsuccess = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
                    var x, _t;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.p = _context.n) {
                        case 0:
                          _this2.localDB = event.target.result;
                          console.log('Database opened successfully:', _this2.localDB.name);

                          // Wait for the database initialization logic to complete
                          _context.p = 1;
                          _context.n = 2;
                          return _this2.returnVocab();
                        case 2:
                          x = _context.v;
                          if (x.length > 0) {
                            _this2.show_vocab = true;
                          }

                          // Resolve the Promise after all initialization is done
                          resolve(_this2.localDB);
                          _context.n = 4;
                          break;
                        case 3:
                          _context.p = 3;
                          _t = _context.v;
                          reject(_t);
                        // If something goes wrong during the vocab check
                        case 4:
                          return _context.a(2);
                      }
                    }, _callee, null, [[1, 3]]);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();
                request.onupgradeneeded = function (event) {
                  _this2.localDB = event.target.result;
                  console.log('Database upgrade needed. Creating object stores...');

                  // Create an object store (table) if it doesn't exist
                  if (!_this2.localDB.objectStoreNames.contains('vocabulary')) {
                    var objectStore = _this2.localDB.createObjectStore('vocabulary', {
                      keyPath: 'id',
                      autoIncrement: true
                    });

                    // Create an index if needed
                    objectStore.createIndex('field3', 'field3', {
                      unique: true
                    });
                    objectStore.createIndex('field4', 'field4', {
                      unique: true
                    });
                    objectStore.createIndex('lesson_id', 'lesson_id', {
                      unique: false
                    });
                    objectStore.createIndex('label', 'label', {
                      unique: false
                    });
                    objectStore.createIndex('last_studied', 'last_studied', {
                      unique: false
                    });
                    objectStore.createIndex('srs_rank', 'srs_rank', {
                      unique: false
                    });
                    console.log('Object store "vocabulary" created');
                  }
                };
              }));
          }
        }, _callee2, this);
      }));
      function initializeDatabase() {
        return _initializeDatabase.apply(this, arguments);
      }
      return initializeDatabase;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var i;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Popup, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.initializeDatabase();
            case 3:
              _context3.n = 4;
              return this.doesVocabExist();
            case 4:
              this.show_vocab = _context3.v;
              //
              // urlpath check for subpages
              //
              for (i = 0; i < this.urlpath.length; i++) {
                if (this.urlpath[i] === '') {
                  this.urlpath.splice(i, 1);
                  i--;
                }
                if (this.urlpath[i] === 'popup') {
                  this.browser_active = 1;
                }
                if (this.urlpath[i] === 'lessons') {
                  if (this.urlpath.length > i + 1) {
                    this.app.connection.emit('popup-lessons-render-request');
                  } else {
                    this.app.connection.emit('popup-lessons-render-request');
                  }
                }
              }
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() ////////////
    // render //
    ////////////
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _iterator, _step, mod, cm;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!this.app.options.popup) {
                this.load();
              }

              //
              // create and render components
              //
              if (!(this.main == null)) {
                _context4.n = 2;
                break;
              }
              // initialize components
              this.header = new SaitoHeader(this.app, this);
              _context4.n = 1;
              return this.header.initialize(this.app);
            case 1:
              this.main = new PopupMain(this.app, this);
              this.manager = new PopupLessonManager(this.app, this);
              this.lessonui = new PopupLesson(this.app, this);
              this.review = new PopupReview(this.app, this);
              this.vocab = new PopupVocab(this.app, this);
              this.addComponent(this.header);
              this.addComponent(this.main);

              //
              // chat manager can insert itself into left-sidebar if exists
              //
              _iterator = _createForOfIteratorHelper(this.app.modules.returnModulesRespondingTo('chat-manager'));
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  mod = _step.value;
                  cm = mod.respondTo('chat-manager');
                  cm.container = '.saito-sidebar.left';
                  cm.render_manager_to_screen = 1;
                  this.addComponent(cm);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            case 2:
              _context4.n = 3;
              return _superPropGet(Popup, "render", this, 3)([]);
            case 3:
              if (!(this.urlpath.length >= 2)) {
                _context4.n = 5;
                break;
              }
              if (!(this.urlpath[1] == 'review' || this.urlpath[1] == 'vocab')) {
                _context4.n = 4;
                break;
              }
              this.app.connection.emit('popup-vocab-render-request');
              return _context4.a(2);
            case 4:
              if (!(this.urlpath[1] == 'lessons')) {
                _context4.n = 5;
                break;
              }
              if (this.urlpath.length > 2) {
                if (this.urlpath[2] == 'absolute-beginners') {
                  this.app.connection.emit('popup-lessons-render-request', 'absolute-beginners');
                }
                if (this.urlpath[2] == 'elementary') {
                  this.app.connection.emit('popup-lessons-render-request', 'elementary');
                }
                if (this.urlpath[2] == 'intermediate') {
                  this.app.connection.emit('popup-lessons-render-request', 'intermediate');
                }
                if (this.urlpath[2] == 'advanced') {
                  this.app.connection.emit('popup-lessons-render-request', 'advanced');
                }
                if (this.urlpath[2] == 'film-friday') {
                  this.app.connection.emit('popup-lessons-render-request', 'film-friday');
                }
                if (this.urlpath[2] == 'quiz-night') {
                  this.app.connection.emit('popup-lessons-render-request', 'quiz-night');
                }
              } else {
                this.app.connection.emit('popup-lessons-render-request', 'all');
              }
              return _context4.a(2);
            case 5:
              this.app.connection.emit('popup-home-render-request');
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() ////////////////////////////
    // fetch language content //
    ////////////////////////////
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, peer) {
        var _this3 = this;
        var service,
          popup_self,
          should_push,
          i,
          sql,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              service = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              popup_self = this; //
              // override functions called by non-Saito JS
              //
              if (this.app.BROWSER == 1) {
                //
                // browser should be able to access Saito
                //
                saito_app = app;
                saito_mod = this;
                if (!this.app.options.popup) {
                  this.load();
                }
                save_display_mode = function save_display_mode() {
                  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                  if (mode === 'simplified') {
                    if (popup_self.app.options.popup.display.simplified == 1) {
                      popup_self.app.options.popup.display.simplified = 0;
                      popup_self.app.options.popup.display.traditional = 1;
                    } else {
                      popup_self.app.options.popup.display.simplified = 1;
                      popup_self.app.options.popup.display.traditional = 0;
                    }
                  }
                  if (mode === 'traditional') {
                    if (popup_self.app.options.popup.display.traditional == 1) {
                      popup_self.app.options.popup.display.traditional = 0;
                      popup_self.app.options.popup.display.simplified = 1;
                    } else {
                      popup_self.app.options.popup.display.traditional = 1;
                      popup_self.app.options.popup.display.simplified = 0;
                    }
                  }
                  if (mode === 'pinyin') {
                    if (popup_self.app.options.popup.display.pinyin == 1) {
                      popup_self.app.options.popup.display.pinyin = 0;
                    } else {
                      popup_self.app.options.popup.display.pinyin = 1;
                    }
                  }
                  if (mode === 'english') {
                    if (popup_self.app.options.popup.display.english == 1) {
                      popup_self.app.options.popup.display.english = 0;
                    } else {
                      popup_self.app.options.popup.display.english = 1;
                    }
                  }
                  popup_self.save();
                };
                save_vocab_mode = function save_vocab_mode() {
                  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                  if (mode === 'field1') {
                    if (popup_self.app.options.popup.vocab.field1 == 1) {
                      popup_self.app.options.popup.vocab.field1 = 0;
                    } else {
                      popup_self.app.options.popup.vocab.field1 = 1;
                    }
                  }
                  if (mode === 'field2') {
                    if (popup_self.app.options.popup.vocab.field2 == 1) {
                      popup_self.app.options.popup.vocab.field2 = 0;
                    } else {
                      popup_self.app.options.popup.vocab.field2 = 1;
                    }
                  }
                  if (mode === 'field3') {
                    if (popup_self.app.options.popup.vocab.field3 == 1) {
                      popup_self.app.options.popup.vocab.field3 = 0;
                    } else {
                      popup_self.app.options.popup.vocab.field3 = 1;
                    }
                  }
                  if (mode === 'field4') {
                    if (popup_self.app.options.popup.vocab.field4 == 1) {
                      popup_self.app.options.popup.vocab.field4 = 0;
                    } else {
                      popup_self.app.options.popup.vocab.field4 = 1;
                    }
                  }
                  if (mode === 'field5') {
                    if (popup_self.app.options.popup.vocab.field5 == 1) {
                      popup_self.app.options.popup.vocab.field5 = 0;
                    } else {
                      popup_self.app.options.popup.vocab.field5 = 1;
                    }
                  }
                  popup_self.save();
                };
                add_to_vocab = function add_to_vocab() {
                  var field1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                  var field2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                  var field3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                  var field4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                  var field5 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
                  var label = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
                  if (field1 === 'unknown') {
                    field1 = '';
                  }
                  if (field2 === 'unknown') {
                    field2 = '';
                  }
                  if (field3 === 'unknown') {
                    field3 = '';
                  }
                  if (field4 === 'unknown') {
                    field4 = '';
                  }
                  if (field5 === 'unknown') {
                    field5 = '';
                  }
                  popup_self.addVocab(field1, field2, field3, field4, field5, label);
                };
              }

              //
              // avoid network overhead if in other apps
              //
              if (this.browser_active) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              //
              // load available lessons / media
              //
              if (service.service === 'popup') {
                should_push = true;
                for (i = 0; i < this.peers.length; i++) {
                  if (this.peers[i].publicKey == peer.publicKey) {
                    // refresh / overwrite reference to peer
                    this.peers[i] = peer;
                    should_push = false;
                  }
                }
                if (should_push) {
                  this.peers.push(peer);
                }

                //
                // fetch all available lessons on load
                //
                sql = "\n\t\t\t\tSELECT lessons.id, lessons.title, lessons.content, lessons.slug, lessons.photo, lessons.username, lessons.userslug \n\t\t\t\tFROM lessons \n                   \t\tORDER BY lessons.created_at DESC\n\t\t\t";
                this.sendPeerDatabaseRequestWithFilter('Popup', sql, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
                    var _iterator2, _step2, record;
                    return _regenerator().w(function (_context5) {
                      while (1) switch (_context5.n) {
                        case 0:
                          let_lesson_id = 0;
                          if (!res.rows) {
                            _context5.n = 1;
                            break;
                          }
                          _iterator2 = _createForOfIteratorHelper(res.rows);
                          try {
                            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                              record = _step2.value;
                              _this3.addLesson(record);
                            }
                          } catch (err) {
                            _iterator2.e(err);
                          } finally {
                            _iterator2.f();
                          }
                          if (_this3.manager.waiting_to_display == true) {
                            _this3.manager.render(_this3.manager.level);
                          }
                          return _context5.a(2);
                        case 1:
                          return _context5.a(2);
                      }
                    }, _callee5);
                  }));
                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }(), function (p) {
                  if (p.publicKey == peer.publicKey) {
                    return 1;
                  }
                  return 0;
                });
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //////////////////////
    // Lesson Functions //
    //////////////////////
    //
    //(add, load, return)
    //
  }, {
    key: "addLesson",
    value: function () {
      var _addLesson = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(lesson) {
        var add_me, i;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              add_me = true;
              i = 0;
            case 1:
              if (!(i < this.lessons.length)) {
                _context7.n = 3;
                break;
              }
              if (!(this.lessons[i].id === lesson.id)) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              i++;
              _context7.n = 1;
              break;
            case 3:
              this.lessons.push(lesson);
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function addLesson(_x6) {
        return _addLesson.apply(this, arguments);
      }
      return addLesson;
    }()
  }, {
    key: "loadLessonSentences",
    value: function loadLessonSentences(lesson, mycallback) {
      var _this4 = this;
      if (!lesson) {
        return;
      }
      if (this.peers.length == 0) {
        return;
      }
      var peer = this.peers[0];

      //
      // sentences
      //
      this.sendPeerDatabaseRequestWithFilter('Popup', "SELECT * FROM sentences WHERE lesson_id = ".concat(lesson.id, " ORDER BY display_order ASC"), /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                if (res.rows) {
                  _this4.lesson.sentences = res.rows;
                  mycallback();
                }
              case 1:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function (_x7) {
          return _ref3.apply(this, arguments);
        };
      }(), function (p) {
        if (p.publicKey == peer.publicKey) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "loadLessonWords",
    value: function loadLessonWords(lesson, mycallback) {
      var _this5 = this;
      if (!lesson) {
        return;
      }
      if (this.peers.length == 0) {
        return;
      }
      var peer = this.peers[0];

      //
      // words
      //
      this.sendPeerDatabaseRequestWithFilter('Popup', "SELECT * FROM words WHERE lesson_id = ".concat(lesson.id, " ORDER BY display_order ASC"), /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(res2) {
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                if (res2.rows) {
                  _this5.lesson.words = res2.rows;
                  mycallback();
                }
              case 1:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x8) {
          return _ref4.apply(this, arguments);
        };
      }(), function (p) {
        if (p.publicKey == peer.publicKey) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "loadLessonQuestions",
    value: function loadLessonQuestions(lesson, mycallback) {
      var _this6 = this;
      if (!lesson) {
        return;
      }
      if (this.peers.length == 0) {
        return;
      }
      var peer = this.peers[0];

      //
      // questions
      //
      this.sendPeerDatabaseRequestWithFilter('Popup', "SELECT * FROM questions WHERE lesson_id = ".concat(lesson.id, " ORDER BY display_order ASC"), /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(res3) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                if (res3.rows) {
                  _this6.lesson.questions = res3.rows;
                  mycallback();
                }
              case 1:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x9) {
          return _ref5.apply(this, arguments);
        };
      }(), function (p) {
        if (p.publicKey == peer.publicKey) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "returnLesson",
    value: function returnLesson() {
      var lesson_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      for (var i = 0; i < this.lessons.length; i++) {
        if (this.lessons[i].id == lesson_id) {
          return this.lessons[i];
        }
      }
      return {
        level: 'Unknown',
        title: 'Placeholder Title'
      };
    }

    ///////////////////////
    // network functions //
    ///////////////////////
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (conf == 0) {
                console.log('%%');
                console.log('NEW TRANSACTION RECEIVED!');
                console.log('txmsg: ' + JSON.stringify(txmsg));
              }
            case 1:
              return _context1.a(2);
          }
        }, _callee1);
      }));
      function onConfirmation(_x0, _x1, _x10) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "load",
    value: function load() {
      if (!this.app.BROWSER) {
        return;
      }
      if (!this.app.options.popup) {
        this.app.options.popup = {};
      }
      if (!this.app.options.popup.vocab) {
        this.app.options.popup.vocab = {};
        this.app.options.popup.vocab.field1 = 1;
        this.app.options.popup.vocab.field2 = 1;
        this.app.options.popup.vocab.field3 = 1;
        this.app.options.popup.vocab.field4 = 1;
        this.app.options.popup.vocab.field5 = 0;
      }
      if (!this.app.options.popup.display) {
        this.app.options.popup.display = {};
        this.app.options.popup.display.simplified = 1;
        this.app.options.popup.display.traditional = 0;
        this.app.options.popup.display.pinyin = 1;
        this.app.options.popup.display.english = 1;
        this.app.options.popup.display.part_of_speech = 0;
      }
      if (!this.app.options.popup.review) {
        this.app.options.popup.review = {};
        this.app.options.popup.review.enable = 1;
      }
    }
  }, {
    key: "updatePreference",
    value: function updatePreference(field1, value1) {
      if (!this.app.options.popup) {
        this.load();
      }
      if (field1 == 'display') {
        if (value1 == 'simplified') {
          this.app.options.popup.display.simplified = 1;
        }
        if (value1 == 'traditional') {
          this.app.options.popup.display.traditional = 1;
        }
        if (value1 == 'pinyin') {
          this.app.options.popup.display.pinyin = 1;
        }
        if (value1 == 'english') {
          this.app.options.popup.display.english = 1;
        }
        if (value1 == 'part-of-speech') {
          this.app.options.popup.display.part_of_speech = 1;
        }
      }
      return 1;
    }
  }, {
    key: "save",
    value: function save() {
      var _this$app$options;
      if (!((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.popup)) {
        this.app.options.popup = {};
        this.app.options.popup.display = {};
        this.app.options.popup.display.simplified = 1;
        this.app.options.popup.display.traditional = 1;
        this.app.options.popup.display.pinyin = 1;
        this.app.options.popup.display.english = 1;
        this.app.options.popup.display.part_of_speech = 1;
        this.app.options.popup.review = {};
        this.app.options.popup.review.enable = 1;
      }
      this.app.storage.saveOptions();
    }
  }, {
    key: "doesVocabExist",
    value: function () {
      var _doesVocabExist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var transaction, objectStore, request, count, _t2;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              transaction = this.localDB.transaction(['vocabulary'], 'readonly');
              objectStore = transaction.objectStore('vocabulary');
              request = objectStore.count();
              _context10.n = 1;
              return new Promise(function (resolve, reject) {
                request.onsuccess = function (event) {
                  return resolve(event.target.result);
                };
                request.onerror = function (event) {
                  return reject(event.target.error);
                };
              });
            case 1:
              count = _context10.v;
              return _context10.a(2, count > 0);
            case 2:
              _context10.p = 2;
              _t2 = _context10.v;
              return _context10.a(2, false);
          }
        }, _callee10, this, [[0, 2]]);
      }));
      function doesVocabExist() {
        return _doesVocabExist.apply(this, arguments);
      }
      return doesVocabExist;
    }()
  }, {
    key: "addVocab",
    value: function () {
      var _addVocab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var field1,
          field2,
          field3,
          field4,
          field5,
          label,
          lesson_id,
          obj,
          transaction,
          objectStore,
          request,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              field1 = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : '';
              field2 = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : '';
              field3 = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : '';
              field4 = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : '';
              field5 = _args12.length > 4 && _args12[4] !== undefined ? _args12[4] : '';
              label = _args12.length > 5 && _args12[5] !== undefined ? _args12[5] : '';
              lesson_id = _args12.length > 6 && _args12[6] !== undefined ? _args12[6] : '';
              obj = {};
              obj.field1 = field1 || '';
              obj.field2 = field2 || '';
              obj.field3 = field3 || '';
              obj.field4 = field4 || '';
              obj.field5 = field5 || '';
              obj.lesson_id = lesson_id || 0;
              obj.label = label || '';
              obj.audio_source = '';
              obj.audio_translation = '';
              obj.display_order = 0;
              obj.created_at = new Date().getTime();
              obj.updated_at = new Date().getTime();
              obj.last_correct = 0;
              obj.times_studied = 0;
              obj.times_correct = 0;
              obj.times_incorrect = 0;
              obj.srs_rank = 0;
              transaction = this.localDB.transaction(['vocabulary'], 'readwrite');
              objectStore = transaction.objectStore('vocabulary');
              request = objectStore.add(obj);
              request.onsuccess = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
                return _regenerator().w(function (_context11) {
                  while (1) switch (_context11.n) {
                    case 0:
                      console.log('Vocabulary added successfully:', obj);
                    case 1:
                      return _context11.a(2);
                  }
                }, _callee11);
              }));
              request.onerror = function (event) {
                console.error('Error adding vocabulary:', event.target.error);
              };
            case 1:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function addVocab() {
        return _addVocab.apply(this, arguments);
      }
      return addVocab;
    }()
  }, {
    key: "returnVocab",
    value: function () {
      var _returnVocab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _this7 = this;
        var offset,
          limit,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              offset = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : 0;
              limit = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 10;
              if (this.browser_active) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2);
            case 1:
              if (this.app.BROWSER) {
                _context13.n = 2;
                break;
              }
              return _context13.a(2, []);
            case 2:
              return _context13.a(2, new Promise(function (resolve, reject) {
                var transaction = _this7.localDB.transaction(['vocabulary'], 'readonly');
                var objectStore = transaction.objectStore('vocabulary');
                var request = objectStore.openCursor();
                var allEntries = [];
                var index = 0;
                request.onsuccess = function (event) {
                  var cursor = event.target.result;
                  if (cursor) {
                    if (index >= offset && allEntries.length < limit) {
                      allEntries.push(cursor.value);
                    }
                    index++;
                    cursor["continue"]();
                  } else {
                    console.log('Fetched vocabulary entries:', allEntries);
                    resolve(allEntries);
                  }
                };
                request.onerror = function (event) {
                  console.error('Error fetching vocabulary entries:', event.target.error);
                  reject(event.target.error);
                };
              }));
          }
        }, _callee13, this);
      }));
      function returnVocab() {
        return _returnVocab.apply(this, arguments);
      }
      return returnVocab;
    }()
  }, {
    key: "loadQuestion",
    value: function () {
      var _loadQuestion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _this8 = this;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              return _context14.a(2, new Promise(function (resolve, reject) {
                var question_types = ['multiple_choice_english', 'multiple_choice_pinyin'];
                var question_type = question_types[Math.floor(Math.random() * question_types.length)];
                var tdate1 = new Date().getTime();
                var tdate2 = new Date().getTime() - 172800 * 1000;
                var tdate3 = new Date().getTime() - 518400 * 1000;
                var tdate4 = new Date().getTime() - 1123200 * 1000;
                var tdate5 = new Date().getTime() - 2419200 * 1000;
                var tdate6 = new Date().getTime() - 4924800 * 1000;
                var tdate7 = new Date().getTime() - 14774400 * 1000;
                var transaction = _this8.localDB.transaction(['vocabulary'], 'readonly');
                var objectStore = transaction.objectStore('vocabulary');

                // Use a cursor to fetch and filter records
                var request = objectStore.openCursor();
                var rows = [];
                var last_entry = '';
                request.onsuccess = function (event) {
                  var cursor = event.target.result;
                  if (cursor) {
                    // Check the conditions for filtering the rows
                    if (cursor.value.srs_rank === 0 || cursor.value.srs_rank === 1 && cursor.value.last_studied < tdate1 || cursor.value.srs_rank < 2 && cursor.value.last_studied < tdate2 || cursor.value.srs_rank < 3 && cursor.value.last_studied < tdate3 || cursor.value.srs_rank < 4 && cursor.value.last_studied < tdate4 || cursor.value.srs_rank < 5 && cursor.value.last_studied < tdate5 || cursor.value.srs_rank < 6 && cursor.value.last_studied < tdate6 || cursor.value.srs_rank < 7 && cursor.value.last_studied < tdate7) {
                      rows.push(cursor.value);
                    }
                    last_entry = cursor.value;
                    cursor["continue"]();
                  } else {
                    if (rows.length == 0) {
                      if (last_entry) {
                        rows.push(last_entry);
                      }
                    }

                    // Resolve with a random row if rows exist
                    if (rows.length > 0) {
                      var idx = Math.floor(Math.random() * rows.length);
                      var word = rows[idx];
                      var words = [];
                      var options = [];
                      var shuffleArray = function shuffleArray(array) {
                        return array.sort(function () {
                          return Math.random() - 0.5;
                        });
                      };
                      if (rows.length > 4) {
                        while (options.length < 4) {
                          shuffleArray(rows);
                          if (!options.includes(rows[0].field1)) {
                            words.push(rows[0]);
                            options.push(rows[0].field1);
                          }
                        }
                      } else {
                        words.push({
                          english: 'good',
                          pinyin: 'hao3',
                          field1: 'good',
                          field2: 'hao3',
                          field3: '好',
                          field4: '好'
                        });
                        words.push({
                          english: 'ok',
                          pinyin: 'xing2',
                          field1: 'ok',
                          field2: 'xing2',
                          field3: '行',
                          field4: '行'
                        });
                        words.push({
                          english: 'to eat',
                          pinyin: 'chi1',
                          field1: 'to eat',
                          field2: 'chi1',
                          field3: '吃',
                          field4: '吃'
                        });
                        words.push({
                          english: 'to go',
                          pinyin: 'zou3',
                          field1: 'to go',
                          field2: 'zou3',
                          field3: '走',
                          field4: '走'
                        });
                      }

                      //
                      // substitute random entry for our test
                      //
                      var correct = Math.floor(Math.random() * 4);
                      if (word != null) {
                        words[correct] = word;
                      } else {
                        word = words[correct];
                      }
                      var option1 = '';
                      var option2 = '';
                      var option3 = '';
                      var option4 = '';
                      var question = '';
                      var english = '';

                      //
                      // options depend on question type
                      //
                      if (question_type === 'multiple_choice_english') {
                        option1 = words[0].field1;
                        option2 = words[1].field1;
                        option3 = words[2].field1;
                        option4 = words[3].field1;
                        question = word.field3;
                        english = word.field1;
                        pinyin = word.field2;
                      }
                      if (question_type === 'multiple_choice_pinyin') {
                        option1 = words[0].field2;
                        option2 = words[1].field2;
                        option3 = words[2].field2;
                        option4 = words[3].field2;
                        question = word.field3;
                        english = word.field1;
                        pinyin = word.field2;
                      }
                      obj = {
                        lesson_id: word.lesson_id,
                        word_id: word.id,
                        question_type: question_type,
                        question: question,
                        english: english,
                        pinyin: pinyin,
                        language: 'chinese',
                        option1: option1,
                        option2: option2,
                        option3: option3,
                        option4: option4,
                        correct: "option".concat(correct + 1),
                        answer: '',
                        hint: '',
                        source_audio_url: 'http://popupchinese.com/data/'
                      };
                      resolve(obj);
                    } else {
                      resolve(null); // No matching rows found
                    }
                  }
                };
                request.onerror = function (event) {
                  console.error('Error fetching vocabulary:', event.target.error);
                  reject(event.target.error); // Reject on error
                };
              }));
          }
        }, _callee14);
      }));
      function loadQuestion() {
        return _loadQuestion.apply(this, arguments);
      }
      return loadQuestion;
    }()
  }, {
    key: "saveAnswer",
    value: function () {
      var _saveAnswer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(obj) {
        var _this9 = this;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              return _context15.a(2, new Promise(function (resolve, reject) {
                // Open a transaction to the 'vocabulary' object store in readwrite mode
                var transaction = _this9.localDB.transaction(['vocabulary'], 'readwrite');
                var objectStore = transaction.objectStore('vocabulary');
                if (!obj) {
                  return;
                }
                if (!obj.wid) {
                  return;
                }

                //	{
                //                wid: wid,
                //                lid: lid,
                //                last_question_data: last_question_data,
                //                requested_wid: requested_wid,
                //                source: source,
                //                correct: answered_correctly
                //	}

                var request = objectStore.get(obj.wid);
                request.onsuccess = function (event) {
                  var word = event.target.result;
                  if (word) {
                    word.updated_at = new Date().getTime(); // Update the timestamp

                    if (obj.correct) {
                      word.last_studied = new Date().getTime();
                      word.last_correct = word.last_studied;
                      word.times_studied++;
                      word.times_correct++;
                      word.srs_rank++;
                    } else {
                      word.last_studied = new Date().getTime();
                      word.times_studied++;
                      word.times_incorrect++;
                      word.srs_rank = 0;
                    }

                    // Put the updated word back into the database
                    var updateRequest = objectStore.put(word);
                    updateRequest.onsuccess = function () {
                      console.log('Vocabulary updated successfully:', word);
                      resolve(word); // Resolve with the updated word
                    };
                    updateRequest.onerror = function (updateError) {
                      console.error('Error updating vocabulary:', updateError.target.error);
                      reject(updateError.target.error); // Reject if there's an error updating
                    };
                  } else {
                    console.error('No word found with the provided ID');
                    reject(new Error('No word found with the provided ID')); // Reject if the word doesn't exist
                  }
                };
                request.onerror = function (event) {
                  console.error('Error retrieving word:', event.target.error);
                  reject(event.target.error); // Reject if there's an error retrieving the word
                };
              }));
          }
        }, _callee15);
      }));
      function saveAnswer(_x11) {
        return _saveAnswer.apply(this, arguments);
      }
      return saveAnswer;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var popup_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug() + '/review'), /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(req, res) {
          var html;
          return _regenerator().w(function (_context16) {
            while (1) switch (_context16.n) {
              case 0:
                html = PopupHome(app, popup_self, app.build_number);
                if (res.finished) {
                  _context16.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context16.a(2, res.send(html));
              case 1:
                return _context16.a(2);
            }
          }, _callee16);
        }));
        return function (_x12, _x13) {
          return _ref7.apply(this, arguments);
        };
      }());
      expressapp.get('/' + encodeURI(this.returnSlug() + '/review/*'), /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(req, res) {
          var html;
          return _regenerator().w(function (_context17) {
            while (1) switch (_context17.n) {
              case 0:
                html = PopupHome(app, popup_self, app.build_number);
                if (res.finished) {
                  _context17.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context17.a(2, res.send(html));
              case 1:
                return _context17.a(2);
            }
          }, _callee17);
        }));
        return function (_x14, _x15) {
          return _ref8.apply(this, arguments);
        };
      }());
      expressapp.get('/' + encodeURI(this.returnSlug() + '/lessons'), /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(req, res) {
          var html;
          return _regenerator().w(function (_context18) {
            while (1) switch (_context18.n) {
              case 0:
                html = PopupHome(app, popup_self, app.build_number);
                if (res.finished) {
                  _context18.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context18.a(2, res.send(html));
              case 1:
                return _context18.a(2);
            }
          }, _callee18);
        }));
        return function (_x16, _x17) {
          return _ref9.apply(this, arguments);
        };
      }());
      expressapp.get('/' + encodeURI(this.returnSlug() + '/lessons/*'), /*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(req, res) {
          var html;
          return _regenerator().w(function (_context19) {
            while (1) switch (_context19.n) {
              case 0:
                html = PopupHome(app, popup_self, app.build_number);
                if (res.finished) {
                  _context19.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context19.a(2, res.send(html));
              case 1:
                return _context19.a(2);
            }
          }, _callee19);
        }));
        return function (_x18, _x19) {
          return _ref0.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }

    /*
           webServer(app, expressapp, express) {
                   let webdir = `${__dirname}/../../mods/${this.dirname}/web`;
                  let popup_self = this;
                   expressapp.get('/' + encodeURI(this.returnSlug() + '/lessons'), async function (req, res) {
                          let html = PopupHome(app, popup_self, app.build_number);
                          if (!res.finished) {
                                  res.setHeader('Content-type', 'text/html');
                                  res.charset = 'UTF-8';
                                  return res.send(html);
                          }
                          return;
                  });
                   expressapp.get('/' + encodeURI(this.returnSlug() + '/lessons/*'), async function (req, res) {
                          let html = PopupHome(app, popup_self, app.build_number);
                          if (!res.finished) {
                                  res.setHeader('Content-type', 'text/html');
                                  res.charset = 'UTF-8';
                                  return res.send(html);
                          }
                          return;
                  });
       		expressapp.use('/' + encodeURI(this.returnSlug()), express.static(webdir));
    }
    */
  }]);
}(ModTemplate);
module.exports = Popup;